import React from "react";
import styled from 'styled-components';
import AccordionRow from "../tables/table/AccordionRow";
import HeadAccordion from "../tables/table/HeadAccordion";
import ContentAccordion from "../tables/table/ContentAccordion";
import Appointment from "../clinichistory/Appointment";
import Edit from "@mui/icons-material/Edit";
import { useIntl } from "react-intl";
import { Tooltip } from "@mui/material";
import { APPOINTMENT_EDIT_LIMIT } from "../../config";

const Title = styled.div`
width: 100%;
display: flex;
height: 100%;
align-items: center;
justify-content: flex-start;
`

const DateContainer = styled.div`
display: flex;
align-items: center;
justify-content: center;
height: 100%;
margin: 0 10px 0 0;
`

const Name = styled.div`
display: flex;
align-items: center;
justify-content: center;
height: 100%;
`

const EditIcon = styled.div`
position: relative;
display: flex;
align-items: center;
justify-content: flex-end;
width: 100%;
height: 25px;
cursor: pointer;
z-index: 99;
svg {
    font-size: 1.25rem;
}
`

const AppointmentAccordion = ({data, userId, scopes, handleAction, refresh, currentTab}) => {
    
    const intl = useIntl();

    const handleEdit = () => {
        handleAction(data);
    }
    
    const editLimit = (Number.isInteger(APPOINTMENT_EDIT_LIMIT) ? APPOINTMENT_EDIT_LIMIT : 15) * 24 * 60 * 60 * 1000;
    const isEditable = (new Date() - new Date(data.date)) < editLimit;
    
    return (
        <AccordionRow>
            <HeadAccordion>
                <Title>
                    <DateContainer>{intl.formatDate(data.date, {year: "numeric",month: "numeric" ,day: "numeric" })}</DateContainer>
                    <Name>{data.name}</Name>
                </Title>
            </HeadAccordion>
            <ContentAccordion>
        {((isEditable && (userId === parseInt(data.veterinarian?.userManagerId)|| userId === parseInt(data.veterinarianAssistant?.userManagerId) || userId === parseInt(data.createdUser?.userManagerId) || userId === parseInt(data.updatedUser?.userManagerId))) || scopes.includes('root')) &&
                    <EditIcon >
                        <Tooltip title={intl.formatMessage({ id: 'editAppointment' })}>
                            <Edit onClick={handleEdit} />
                        </Tooltip>
                    </EditIcon>
                }
                <Appointment currentTab={currentTab} data={data} refresh={refresh} userId={userId} scopes={scopes} isEditable={isEditable}/>
            </ContentAccordion>
        </AccordionRow>
    )

}

export default AppointmentAccordion;